import { render, staticRenderFns } from "./CargoPackHelpList.vue?vue&type=template&id=0d2ab5e3&"
import script from "./CargoPackHelpList.vue?vue&type=script&lang=js&"
export * from "./CargoPackHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports